// extracted by mini-css-extract-plugin
export default {"statusTag":"statusTag_statusTag__pbpLt"};